module.exports = __webpack_public_path__ + "static/media/artigo.2771d6fd.svg";